import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Users } from '../models/users';
import { LoggerService } from '../services/logger.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {


  contactForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.email, Validators.required]),
  })

  constructor(private fb: FormBuilder, private loggerService: LoggerService) { }

  ngOnInit(): void {
  }

  onSubmit() {
    this.contactForm.reset();
  }

  get firstname() {
    return this.contactForm.get('firstname');
  } 

  get lastname() {
    return this.contactForm.get('lastname');
  } 
 
  get email() {
    return this.contactForm.get('email');
  } 

}


